// import swal from 'sweetalert2'
require("../vendor/cf/scripts/cf");
import { MessageBox } from "element-ui";
import { Notification } from "element-ui";
import { createWriteStream } from "fs";

class MessageHelper {
    constructor() {
        var self = this;
        cf.event.on("cf.dynamicScriptsInitialized", function() {
            self.config.confirm.title = cf.localization.middleware("AreYouSure");
            self.config.confirm.cancelButtonText = cf.localization.middleware("Cancel");
            self.config.confirm.confirmButtonText = cf.localization.middleware("Yes");
        });
        cf.event.on("cf.notifications.received", async (userNotification) => {
            let prop = userNotification.notification.data.properties;
            switch (userNotification.notification.severity) {
                case cf.notifications.severity.SUCCESS:
                    this.success(prop.title, prop.message);
                    break;
                case cf.notifications.severity.WARN:
                    this.warning(prop.title, prop.message);
                    break;
                case cf.notifications.severity.ERROR:
                    this.error(prop.title, prop.message);
                    break;
                case cf.notifications.severity.FATAL:
                    this.error(prop.title, prop.message);
                    break;
                case cf.notifications.severity.INFO:
                    this.info(prop.title, prop.message);
                    break;
                default:
                    break;
            }
            // if (userNotification.notification.notificationName === "App.SimpleMessage") {
            //     Notification({
            //         title: "通知",
            //         message: prop.message,
            //         duration: 0,
            //     });
            // }
        });
    }

    config = {
        info: {
            type: "info",
        },
        sucess: {
            type: "success",
        },
        warning: {
            type: "warning",
        },
        error: {
            type: "error",
        },
        question: {
            type: "question",
        },
        default: {},
        confirm: {
            title: "Are you sure?",
            text: "You will not be able to recover this imaginary file!",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "Cancel",
        },
    };

    showMessage(type, title, message) {
        if (!title) {
            title = message;
            message = undefined;
        }
        var options = $.extend({ position: "bottom-right" }, this.config[type], {
            title: title,
            // dangerouslyUseHTMLString: true,
            // message: '<a href="/helpCenter/questionAdminUser" target="_blank">查看问题详情</a>',
            message: message,
            duration: 0,
        });
        options.onClose = function() {};
        Notification.close();
        return Notification(options);
    }
    confirm(title, message, beforeClose, type) {
        if (!type) {
            type = undefined;
        }
        if (!title) {
            title = message;
            message = undefined;
        }
        var options = $.extend(
            {},
            { type: type },
            {
                title: title,
                message: message,
            }
        );
        if (!beforeClose) {
            beforeClose = () => {};
        }
        options.beforeClose = beforeClose;
        return MessageBox(options);
    }

    info(title, message) {
        return this.showMessage("info", title, message);
    }

    success(title, message) {
        return this.showMessage("success", title, message);
    }

    warning(title, message) {
        return this.showMessage("warning", title, message);
    }

    error(title, message) {
        return this.showMessage("error", title, message);
    }

    // question(title, message) {
    //     return this.showMessage('question', title, message)
    // }

    question(title, message, beforeClose, callback, cancelCallBack) {
        // return swal(options).then(onfulfilled, onrejected)
        return this.confirm(title, message, beforeClose)
            .then(callback)
            .catch(cancelCallBack);
    }
}

export default new MessageHelper();
